import type { ReplicaDatabase } from '../db/replica-database';
import type { StoredRecord } from '../types/stored-record';

/** Store server records, never replacing a newer copy with an older one. */
export async function storeRecords(db: ReplicaDatabase, records: readonly StoredRecord[]): Promise<void> {
  if (records.length === 0) return;
  await db.transaction('rw', db.records, async () => {
    const existing = await db.records.bulkGet(records.map((r) => r.id));
    const newer = records.filter((r, i) => r.rev >= (existing[i]?.rev ?? 0));
    await db.records.bulkPut(newer);
  });
}
